import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#F5F5F0] py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/0273dd44fb07edcab3400783208c41a6/6a2b628e8161088f2d883f2cd1004b23.png" 
              alt="wonder craft company" 
              className="h-8"
            />
          </div>

          <nav className="flex flex-wrap justify-center gap-8">
            <Link
              to="/company"
              className="text-sm font-medium tracking-wider text-black hover:text-gray-600 transition-colors whitespace-nowrap"
            >
              COMPANY
            </Link>
            <Link
              to="/service"
              className="text-sm font-medium tracking-wider text-black hover:text-gray-600 transition-colors whitespace-nowrap"
            >
              SERVICE
            </Link>
            <Link
              to="/news"
              className="text-sm font-medium tracking-wider text-black hover:text-gray-600 transition-colors whitespace-nowrap"
            >
              NEWS
            </Link>
            <Link
              to="/contact"
              className="text-sm font-medium tracking-wider text-black hover:text-gray-600 transition-colors whitespace-nowrap"
            >
              CONTACT
            </Link>
          </nav>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-300">
          <p className="text-sm text-gray-600 text-center md:text-left">
            © 2026 wondercraftcompany. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
